import {
  Avatar,
  Card,
  Checkbox,
  ListItem,
  ListItemText,
  Grid,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import bankCardStyle from "./OtherFIUCard.styles";
import sizeFontCustom from "../Discovery/fontSize.styles"
import { useState } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { removeFipIdDots } from "../../utils/helper.utils";

function OtherFIUCard({
  xs,
  md,
  lg,
  bankObject,
  handleOtherFipCheckboxChange,
  checkedBanksList,
  fontSize,
  boxShadow,
  height,
  customDetails,
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  
  // Check for dark theme
  const isDark = customDetails?.darkTheme === true || theme.palette.mode === 'dark';

  const handleTooltipClick = () => {
    if (!isTooltipOpen && checkedBanksList?.length >= 5) setIsTooltipOpen(true);
    else setIsTooltipOpen(!isTooltipOpen);
  }

  const handleClick = (event) => { event.target.checked = true 
    return  handleOtherFipCheckboxChange(event, bankObject)}
  return (
    <Grid item xs={xs} sm={6} md={md} lg={lg} sx={{ pt: "0.94rem!important" }}>
      <Tooltip
        title={t('fipSelection.maxFive')}
        arrow
        open={isTooltipOpen}
        sx={{ border: "sloid" }}
      >
        <Card
          onClick={checkedBanksList?.length < 5 ? handleClick : handleTooltipClick}
          sx={{
            ...bankCardStyle.card,
            cursor:"pointer",
            boxShadow: { boxShadow },
            height: { height },
            backgroundColor: isDark ? '#2D2D2D' : '#FFFFFF',
            color: isDark ? '#FFFFFF' : '#000000',
            border: isDark ? '1px solid #7A8185' : '0.0625rem solid var(--storke-stroke-light, #E3E9EE)',
            transition: 'all 0.2s ease-in-out',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: isDark ? '#3D3D3D' : '#F8F9FA',
              transform: 'translateY(-2px)',
              boxShadow: isDark ? '0 4px 8px rgba(0,0,0,0.3)' : '0 4px 8px rgba(0,0,0,0.1)',
            },
          }}
        >
          <ListItem sx={bankCardStyle.listItem}>
            <Avatar
              src={bankObject?.productIconUri}
              alt={bankObject?.bankName}
              sx={bankCardStyle.avatar}
            />
            <ListItemText
              primary={
                <Typography
                  sx={{
                    ...bankCardStyle.bankName,
                    ...sizeFontCustom.subHeading,
                    color: isDark ? '#FFFFFF' : 'inherit',
                  }}
                >
                 {t(`fips.${removeFipIdDots(bankObject.fipId)}`)}
                </Typography>
              }
            />
            {global?.allowMultipleFipDiscovery === "true" && 
              <Checkbox
                disableTouchRipple
                disableRipple
                disabled={checkedBanksList?.length >= 5}
                sx={{ 
                  paddingRight: "0",
                  color: isDark ? '#7A8185' : '#D8E1EE',
                  '&.Mui-checked': {
                    color: customDetails?.primaryColor || '#3053D3',
                  },
                  '&.Mui-disabled': {
                    color: isDark ? '#7A8185' : '#D8E1EE',
                  },
                  '&:hover': {
                    backgroundColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)',
                  },
                }}
                // checked={checkedBanksList.some((bank) => bank.fipId === bankObject.fipId)}
                // onChange={(event) => handleOtherFipCheckboxChange(event, bankObject)}
              />
              }
          </ListItem>
        </Card>
      </Tooltip>
    </Grid>
  );
}

export default OtherFIUCard;
